import * as React from "react";
import Session from "services/Session";

interface IProps { }

type Props = IProps;

const AppTitle: React.FC<Props> = (props) => {
    return <span>{Session.appTheme.title}</span>;
}


export default AppTitle;
